export default __webpack_public_path__ + "static/media/admin-acesso-exclusivo.3292d056.jpg";